import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, Observable } from 'rxjs';
import * as Entities from '@shared/entities';
import { ConfigService } from '../services/config.service';
import { ListResponse, Result } from '@shared/models';
import { SearchRetailerPhoneNumbersRequest } from '@shared/entities/entities';

@Injectable({
  providedIn: 'root',
})
export class RetailerPhoneNumbersApi {
  serviceUri = '';

  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) {
    this.config.Config.subscribe((config) => {
      if (config?.apiUri) {
        this.serviceUri = `${config.apiUri}/retailers/`;
      }
    });
  }

  async load(_force: boolean, retailerId: number): Promise<Entities.RetailerPhoneNumber[]> {
    const result = await lastValueFrom(
      this.http.get<Result<ListResponse<Entities.RetailerPhoneNumber>>>(
        this.serviceUri + retailerId + '/phone-numbers/'
      )
    );
    if (result.successful && result.data) {
      return result.data.records;
    }

    return [];
  }

  search(request: SearchRetailerPhoneNumbersRequest): Observable<Result<ListResponse<Entities.RetailerPhoneNumber>>> {
    return this.http.post<Result<ListResponse<Entities.RetailerPhoneNumber>>>(
      this.serviceUri + 'phone-numbers/search',
      request
    );
  }
}
